var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowRightBlack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\xC9l\\xE9ments",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icones/->/Suivant/Fill/Noir",
    className: "st0-fill",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.8447,12.5031 C20.8647,12.4691 20.8937,12.4421 20.9087,12.4071 C20.9657,12.2821 20.9997,12.1461 20.9997,12.0001054 C20.9997,11.8541 20.9657,11.7171 20.9087,11.5921 C20.8937,11.5571 20.8647,11.5301 20.8447,11.4961 C20.7937,11.4111 20.7397,11.3311 20.6657,11.2651 C20.6567,11.2551 20.6517,11.2411 20.6407,11.2321 L14.6407,6.2321 C14.2147,5.8781 13.5847,5.9361 13.2317,6.3591 C12.8777,6.7841 12.9357,7.4141 13.3597,7.7681 L17.2377,11.0001054 L3.9997,11.0001054 C3.4477,11.0001054 2.9997,11.4471 2.9997,12.0001054 C2.9997,12.5521 3.4477,13.0001054 3.9997,13.0001054 L17.2377,13.0001054 L13.3597,16.2321 C12.9357,16.5851 12.8777,17.2151 13.2317,17.6401 C13.4297,17.8771 13.7137,18.0001054 14.0007,18.0001054 C14.2267,18.0001054 14.4527,17.9231 14.6407,17.7681 L20.6407,12.7681 C20.6517,12.7581 20.6567,12.7441 20.6657,12.7341 C20.7397,12.6681 20.7937,12.5881 20.8447,12.5031",
    id: "Fill-1"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightBlack);
export default __webpack_public_path__ + "static/media/arrow-right-black.c6d82e482aa47a0f4a2d1bc48cc26d07.svg";
export { ForwardRef as ReactComponent };